import OrderColumnFilter from './OrderColumnFilter';
import OrderMemoInput from '../../../../Component/UI/OrderMemoInput';
import OrderItemStatus from '../../../../Component/UI/OrderItemStatus';
import { claimRefundState } from '../../../../Component/UI/orderClaimProgress';
import OrderAddressText from '../../../../Component/UI/OrderAddressText';
import { linkedOrderRowLayout, OrderRowLayout } from "../../../../Component/orderRowLayout";
import { sellerGiftSourceOrder } from "../../../../Component/sellerGifts";
import { useOrderGiftItems, OrderGiftGridCells } from "../../../../Component/UI/SellerGiftList";
import OrderProductPaymentCells from './OrderProductPaymentCells';
import OrderDeliveryCells from './OrderDeliveryCells';
import BankRefundCell from './BankRefundCell';
import OrderPaymentCells, { hasCompletedRefund } from './OrderPaymentCells';
import React from "react";

import { OrderListprops } from "../../../../Component/Interface/Order";
import { CheckBox } from "../../../../Component/style/common_style";
import {
  OrderCell,
  OrderHeaderCell,
  OrderTable,
  OrderTableHeader,
  RenderOrderCells,
} from "../../../../Component/style/orderTable_style2";

// 헤더/바디가 같은 컬럼 순서·너비를 공유해야 정렬이 안 어긋난다 — 이 배열이 유일한 기준(SSOT).
const gridColumns = (showProcurement: boolean) => [
  "8rem", // 주문번호
    "8rem", // 주문상세번호
    "10rem", // 주문일시
  ...(showProcurement ? ["8rem"] : []), // 발주차수
  "12rem", // 주문상태

  "10rem", // 상태변경일
  "10rem", // 택배 상태
  "8rem", // 주문자
  "10rem", // 입금자
  "8rem", // 상품코드
  "minmax(28rem, 3fr)", // 품목명
  "minmax(10rem, 1fr)", // 옵션
  "minmax(8rem, 1fr)", // 단가
  "6rem", // 수량
  "8rem", // 할인 금액
    "minmax(10rem, 1fr)", // 총 금액
  "6rem", // 택배비
  "minmax(10rem, 1fr)", // 총 결제금액
    "12rem", "13rem", "12rem", "13rem", "20rem", // PG/무통장 금액과 확인일시
  "8rem", // 받는 분
  "12rem", // 받는 분 전화
  "7rem", // 받는 분 우편번호
  "minmax(20rem, 2fr)", // 받는 분 주소
  "minmax(16rem, 1.8fr)", // 배송시 요청사항
  "8rem", // 택배사
  "12rem", // 송장번호
  "minmax(14rem, 4fr)", // 메모
].join(" ");

const Order_all = ({
  list,
  total,
  selectOrder,
  setSelectOrder,
  select_status,
  setSelect_status,
  modify_memo,
  onBankRefund,
  showProcurement = false,
}: OrderListprops & { showProcurement?: boolean }) => {
  const columns = gridColumns(showProcurement);
  const minWidth = 337 + (showProcurement ? 8 : 0);
  const giftItems = useOrderGiftItems();
  const setting_check_list = (seq: number) => {
    if (select_status !== "") {
      if (
        !window.confirm("모든 주문 선택이 취소됩니다.\n취소하시겠습니까?")
      ) {
        return;
      }
      if (setSelect_status) setSelect_status("");
      return;
    }

    if (!selectOrder || !setSelectOrder) {
      return;
    }
    const copyArr = selectOrder.includes(seq)
      ? selectOrder.filter((item) => item !== seq)
      : [...selectOrder, seq];
    setSelectOrder(copyArr);
  };

  const all_check = () => {
    if (select_status !== "" && setSelect_status) return setSelect_status("");
    if (!setSelectOrder || !selectOrder) return;

    const allDetailSeqs = list.flatMap((order) =>
      order.order_details.map((detail) => detail.detail_seq)
    );

    if (isChecked_all()) {
      setSelectOrder([]);
    } else {
      setSelectOrder(allDetailSeqs);
    }
  };

  const isChecked_all = () => {
    if (select_status !== "") return true;
    if (!selectOrder || selectOrder.length === 0) return false;
    const allDetailSeqs = list.flatMap((order) =>
      order.order_details.map((detail) => detail.detail_seq)
    );
    return allDetailSeqs.length > 0 && allDetailSeqs.every((seq) => selectOrder.includes(seq));
  };
  const isChecked_item = (detail_seq: number) => {
    if (select_status !== "") return true;
    if (selectOrder?.includes(detail_seq)) return true;
    return false;
  };

  return (
    <>
      <OrderTableHeader $columns={columns} $minWidth={minWidth}>
        <OrderHeaderCell><OrderColumnFilter>주문번호</OrderColumnFilter></OrderHeaderCell><OrderHeaderCell><OrderColumnFilter>주문상세번호</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>주문일시</OrderColumnFilter></OrderHeaderCell>
        {showProcurement && <OrderHeaderCell><OrderColumnFilter>발주차수</OrderColumnFilter></OrderHeaderCell>}
        <OrderHeaderCell><OrderColumnFilter>주문상태</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>상태변경일</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>택배 상태</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>주문자</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>입금자</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>상품코드</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>품목명</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>옵션</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>단가</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>수량</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>할인 금액</OrderColumnFilter></OrderHeaderCell>
          <OrderHeaderCell><OrderColumnFilter>총 금액</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>택배비</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>총 결제금액</OrderColumnFilter></OrderHeaderCell>
          <OrderHeaderCell><OrderColumnFilter>PG 결제금액</OrderColumnFilter></OrderHeaderCell><OrderHeaderCell><OrderColumnFilter>PG 결제일시</OrderColumnFilter></OrderHeaderCell>
          <OrderHeaderCell><OrderColumnFilter>무통장 입금액</OrderColumnFilter></OrderHeaderCell><OrderHeaderCell><OrderColumnFilter>무통장 입금 확인일시</OrderColumnFilter></OrderHeaderCell>
          <OrderHeaderCell><OrderColumnFilter>무통장 환불</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>받는 분</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>받는 분 전화</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>받는 분 우편번호</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>받는 분 주소</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>배송시 요청사항</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>택배사</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell><OrderColumnFilter>송장번호</OrderColumnFilter></OrderHeaderCell>
        <OrderHeaderCell className="last"><OrderColumnFilter>메모</OrderColumnFilter></OrderHeaderCell>
      </OrderTableHeader>

      {list.map((data, idx) => {
        const gifts = giftItems.filter(gift => sellerGiftSourceOrder(gift) === data.seq
          && (gift.source_product_seq == null || data.order_details.some(detail => Number(detail.product_seq) === Number(gift.source_product_seq))));
        const layout = linkedOrderRowLayout(data.order_details, gifts);
          const rowHeight = layout.rowCount;
        const total_payment = (data.payment_summary ? data.payment_summary.pg_amount + data.payment_summary.bank_amount : Number(data.total_payment) + Number(data.delivery_price || 0)).toLocaleString("ko-KR");

        return (
          <OrderRowLayout.Provider key={data.seq} value={layout}><OrderTable aria-label={`주문 ${data.seq}`} 
            key={data.seq}
            className={idx % 2 === 0 ? "" : "x2"}
            $columns={columns}
            $minWidth={minWidth}
            $height={rowHeight}
          >
            <OrderGiftGridCells items={gifts} firstRow={(data.order_details.length || 1) + 1} columns={Object.fromEntries(Object.entries({
              2: 'number', 3: 'date', 4: 'status', 5: 'blank', 6: 'blank', 9: 'product', 10: 'name', 11: 'option', 12: 'amount', 13: 'quantity',
              14: 'amount', 15: 'amount', 23: 'recipient', 24: 'phone', 25: 'postcode', 26: 'address', 28: 'blank', 29: 'blank', 30: 'memo',
            }).map(([col, value]) => [Number(col) + (showProcurement && Number(col) >= 4 ? 1 : 0), value]).concat(showProcurement ? [[4, 'blank']] : [])) as any} />
            <OrderCell>{data.seq}</OrderCell><RenderOrderCells detailData={data.order_details} searchkey="seq_check" renderCell={seq => seq} />
            <RenderOrderCells detailData={data.order_details} searchkey={"주문일시"} />
            {showProcurement && <RenderOrderCells detailData={data.order_details} searchkey="seq_check" renderCell={detailSeq => {
              const round = data.order_details.find(detail => detail.detail_seq === detailSeq)?.procurement_round;
              return round ? `${round}차 발주` : '-';
            }} />}
            <RenderOrderCells detailData={data.order_details} searchkey="seq_check" renderCell={detailSeq => {
              const detail = data.order_details.find(detail => detail.detail_seq === detailSeq)!;
              const hasActiveClaim = data.claims?.some(claim => claim.items.some(item => item.detail_seq === detailSeq
                && claim.status !== 'unavailable' && !['completed', 'unavailable'].includes(claimRefundState({
                  ...claim, refund_status: item.refund_status ?? claim.refund_status,
                  transfer_status: item.transfer_status === undefined ? claim.transfer_status : item.transfer_status,
                  status_correction: item.status_correction || claim.status_correction,
                }))));
              if (detail.order_status === '결제완료' && Number(detail.cancel_cnt) > 0 && Number(detail.cancel_cnt) < detail.order_cnt
                && hasCompletedRefund(data, detail.payment_method === 'bank' ? 'bank' : 'pg', detailSeq)
                && !Number(detail.refund_summary?.pending_amount) && !hasActiveClaim)
                return <OrderAddressText address="결제 완료 (부분 환불)" />;
              return <OrderItemStatus detailSeq={detailSeq} quantity={detail.order_cnt} status={detail.order_status} claims={data.claims} cancellations={data.claim_cancellations} />;
            }} />

            <RenderOrderCells detailData={data.order_details} searchkey={"상태변경일"} />
            <RenderOrderCells detailData={data.order_details} searchkey="택배 상태" />

            <OrderCell><OrderAddressText address={data.order_name + (data.buyer_withdrawn ? " (탈퇴 회원)" : "")} /></OrderCell>
            <OrderCell><OrderAddressText address={data.order_nickname || "-"} /></OrderCell>

            {["상품코드", "품목명", "옵션", "단가", "수량"].map((key) => (
              <RenderOrderCells key={key} detailData={data.order_details} searchkey={key} />
            ))}

            <OrderProductPaymentCells details={data.order_details} />
            <OrderCell>{data.delivery_price}</OrderCell>
            <OrderCell>{total_payment}</OrderCell>
              <OrderPaymentCells summary={data.payment_summary} order={data} />
              <BankRefundCell order={data} onRefund={onBankRefund} />
            <OrderDeliveryCells order={data} />
            <OrderCell><OrderAddressText address={data.request_memo || data.order_inquiry || "-"} /></OrderCell>

            <RenderOrderCells detailData={data.order_details} searchkey={"택배사"} />
            <RenderOrderCells detailData={data.order_details} searchkey={"송장번호"} />

            <RenderOrderCells
              detailData={data.order_details}
              searchkey={"seq_check"}
              className="last"
              renderCell={(detail_seq) => {
                const currentMemo =
                  data.order_details.find((d) => d.detail_seq === detail_seq)
                    ?.admin_memo || "";
                return (
                  <OrderMemoInput memo={currentMemo} onCommit={nextMemo => modify_memo?.(detail_seq, "admin_memo", nextMemo)} />
                );
              }}
            />
          </OrderTable></OrderRowLayout.Provider>
        );
      })}
    </>
  );
};

export default Order_all;



